import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lease-error',
  templateUrl: './non-legacy-leases-error.component.html',
  styleUrls: ['./non-legacy-leases-error.component.css']
})

export class NonLegacyLeasesErrorComponent implements OnInit {
  errorMessage: string;
  constructor() { 
    this.errorMessage = localStorage.getItem('LeaseErrorMessage');
  }

  ngOnInit() {
  }
}
